(ns practitest.frontend.components2.info-note
  (:require [practitest.frontend.components.icons :as icons]))

(defn mux-info-note
  "Renders an info note banner with an info icon and a message.
   Accepts a string or hiccup as `message`."
  [{:keys [message]}]
  [:p.mux-info-note
   [icons/mux-info-circle]
   message])
